<script setup>
// Cartao colapsavel da barra lateral, com memoria POR AGENTE.
//
// A coluna tem ~300px e empilhava 17 cartoes de peso igual. Quem vive nos
// deals nao quer rolar por Atributos toda vez; quem so atende nem olha para
// Atribuicao. Cada um fecha o que nao usa e o painel para de brigar com ele.
// O estado vai para user.ui_settings (mesmo lugar das reacoes): sem migration,
// sem endpoint, e acompanha o agente entre contas e navegadores.
import { computed } from 'vue';
import { useUISettings } from 'dashboard/composables/useUISettings';

const props = defineProps({
  // Chave estavel do cartao (nao usar o titulo: ele muda com o idioma)
  cardKey: { type: String, required: true },
  title: { type: String, required: true },
  icon: { type: String, default: '' },
  // Classes da pastilha do icone (fundo tingido + cor) — e a ancora visual
  // que separa as secoes de relance
  iconColor: { type: String, default: 'bg-n-slate-3 text-n-slate-10' },
  count: { type: [Number, String], default: null },
  // Cartoes de uso esporadico nascem fechados
  defaultOpen: { type: Boolean, default: true },
});

const UI_KEY = 'sidebar_cards_closed';

const { uiSettings, updateUISettings } = useUISettings();

const closedList = computed(() => uiSettings.value?.[UI_KEY] || []);

const isOpen = computed(() =>
  props.defaultOpen
    ? !closedList.value.includes(props.cardKey)
    : closedList.value.includes(`open:${props.cardKey}`)
);

// Guardamos so o DESVIO do padrao — assim mudar o padrao de um cartao no
// futuro nao briga com a escolha antiga de quem nunca o tocou.
const toggle = () => {
  const lista = [...closedList.value];
  const chave = props.defaultOpen ? props.cardKey : `open:${props.cardKey}`;
  const idx = lista.indexOf(chave);
  if (idx >= 0) lista.splice(idx, 1);
  else lista.push(chave);
  updateUISettings({ [UI_KEY]: lista });
};
</script>

<template>
  <div class="sidebar-card">
    <button
      class="flex items-center gap-2 w-full px-4 py-2.5 text-left transition-colors hover:bg-n-alpha-1 rounded-t-[10px]"
      :class="{ 'rounded-b-[10px]': !isOpen }"
      @click="toggle"
    >
      <span
        v-if="icon"
        class="grid size-6 shrink-0 place-content-center rounded-[7px]"
        :class="iconColor"
      >
        <span :class="`${icon} size-3.5`" />
      </span>
      <span class="text-[12.5px] font-bold tracking-[-0.01em] text-n-slate-12">
        {{ title }}
      </span>
      <span
        v-if="count !== null && count !== ''"
        class="rounded-full bg-n-alpha-1 px-1.5 py-px text-[10.5px] tabular-nums text-n-slate-10"
      >
        {{ count }}
      </span>
      <span
        class="i-lucide-chevron-down size-3.5 text-n-slate-9 ml-auto transition-transform"
        :class="{ '-rotate-90': !isOpen }"
      />
    </button>
    <div v-show="isOpen" class="px-4 pb-3 -mt-0.5">
      <slot />
    </div>
  </div>
</template>
